import UpgradeAccountBanner from './UpgradeAccountBanner';

export default UpgradeAccountBanner;
